export default class GameLockedError extends Error {
  constructor (...args) {
    super(...args)
    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(this, GameLockedError)
    }
  }
}
